import React from "react";
import { Navigate } from "react-router-dom";
import UserRoles from "../../constants/UserRoles";

function AdminRoute({ children }) {
	const checkingLocalStorage = localStorage.getItem("userApuestaco");
	const parsedUserInfo = checkingLocalStorage
		? JSON.parse(checkingLocalStorage)
		: null;

	if (parsedUserInfo?.role !== UserRoles.AdminUser) {
		return <Navigate to='/' replace />;
	}

	return children;
}

export { AdminRoute };